<template>
  <DropdownMenuSeparator v-bind="props" class="-mx-1 my-1 h-px" />
</template>

<script setup>
import { DropdownMenuSeparator } from 'radix-vue';

const props = defineProps({});
</script>
